export interface LoadedConfig {
	appConfig: AppConfig;
}

export enum Brand {
	Bread = "bread",
	Rbc = "rbc",
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const localEnvironments = ["local", "slice"] as const;
export type LocalEnvironment = (typeof localEnvironments)[number];

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const developmentEnvironments = ["dev", "npp-dev-ads"] as const;
export type DevelopmentEnvironment = (typeof developmentEnvironments)[number];

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const qaEnvironments = ["qa-rome", "npp-qa-ads"] as const;
export type QAEnvironment = (typeof qaEnvironments)[number];

const previewEnvironments = ["pv-rome", "sp-pv-ads"] as const;
export type PreviewEnvironment = (typeof previewEnvironments)[number];

const productionEnvironments = ["prod-rome", "pp-prod-ads"] as const;
export type ProductionEnvironment = (typeof productionEnvironments)[number];

export type Environment =
	| LocalEnvironment
	| DevelopmentEnvironment
	| QAEnvironment
	| PreviewEnvironment
	| ProductionEnvironment
	// Rakesh Sukla (slack: @Rakesh) said this is rarely used but to keep it
	| "loadtest";

export interface AppConfig {
	apiurl: string;
	checkouturl: string;
	classicurl: string;
	helpurl?: string;
	signageurl?: string;
	authtoken: string;
	brand: Brand;
	datadogrumapplicationid: string;
	datadogrumclienttoken: string;
	defaultcalltimeout: number;
	env: Environment;
	oktaclientid: string;
	oktaissuer: string;
	sentrytoken: string;
	usefakeauth: boolean;
	sandbox: boolean;
	adobetagmanagerurl: string;
	programgroupswithoutmaxcartsize: string[];
	mswenabled: boolean;
}

export interface BuildConfig {
	name: string;
	version: string;
}

interface GetConfigParams<T> {
	safeReturn?: boolean;
	defaultValue?: T;
}

export function getConfig<T extends string | number | boolean | string[] = string>(
	configKey: keyof AppConfig | keyof BuildConfig,
	params?: GetConfigParams<T>,
): T {
	const { safeReturn = false, defaultValue } = params || {};
	if (window.AppConfig && window.BuildConfig) {
		const Config = { ...window.AppConfig, ...window.BuildConfig };
		if (configKey in Config) {
			return Config[configKey] as T;
		}
	}

	if (safeReturn) {
		return defaultValue;
	}

	throw new Error(`Unknown config: ${configKey}`);
}

export const isPreviewEnvironment = (): boolean => {
	const env = getConfig<Environment>("env");
	return previewEnvironments.indexOf(env as PreviewEnvironment) !== -1;
};

export const isProductionEnvironment = (): boolean => {
	const env = getConfig<Environment>("env");
	return productionEnvironments.indexOf(env as ProductionEnvironment) !== -1;
};

export const tenants = {
	ROME: "rome",
	ADS: "bread",
};
